module.exports = __webpack_public_path__ + "static/media/preview-thumbnail-3.0eb705df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pseudodocs/preview-thumbnail-3.jpg
// module id = 1889
// module chunks = 2